"use strict";
/**
 * Force Majeure Declaration Request Types
 *
 * API request contracts for force-majeure declaration endpoints. A single
 * declaration covers everyone (or a branch) for the given day(s); affected
 * collaborators are resolved at attendance-read time (individual time-off wins).
 *
 * @example POST /api/force-majeure
 * @example PATCH /api/force-majeure/:id
 */
Object.defineProperty(exports, "__esModule", { value: true });
